import { Component, ViewChild } from '@angular/core';
import { WheelSelector } from '@ionic-native/wheel-selector';
import { NavController, NavParams, AlertController, ModalController, ActionSheetController, ActionSheet, Platform, Content, MenuController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { TranslateService } from 'ng2-translate';

import { IEmployee, Employee, ITimeRegistration, TimeRegistration, IProject, Project, IApprover } from '../../../model/top.model';

import { EmployeeData } from '../../../providers/employee-data';
import { TimeRegistrationData } from '../../../providers/time-registration-data';

import { SelectProjectModal } from "../../../modals/select-project/select-project";
import { EditTextModal } from '../../../modals/edit-text/edit-text';
import { Gender, EditMode, TimeRegistrationStatus, TimeRegistrationType, Jobrole, jobRoles } from '../../../enums/enums';

import { TimeRegistrationStatusPipe, TimeRegistrationTypePipe, TimeRegistrationsByWeek } from '../../../pipes/time-registration-pipe/time-registration-pipe';
import { JobrolesPipe } from '../../../pipes/employee-pipe/employee-pipe';
import { ProjectData } from '../../../providers/project-data';

@Component({
  selector: 'page-employee-details',
  templateUrl: 'employee-details.html'
})
export class EmployeeDetailsPage {
  @ViewChild(Content) content: Content;

  private canLeave: boolean;
  private actionSheet: ActionSheet;
  private weekInMilliseconds: number = 604800000;
  private months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  private maxWeeks: number;
  private employeeTimeRegistrationTypes: Array<TimeRegistrationType>;

  employee: Employee;
  loggedInEmployee: Employee;
  mode: EditMode;
  formGroupEmployee: FormGroup;
  gender;
  isMobile: boolean;
  isAndroid: boolean;
  editMode;
  isTimeRegistration: boolean = true;
  jobRoles = jobRoles;
  month: string;
  // private selectedJobRoles: Object = { Administrator: false, Manager: false, Service: false, Voorman: false, Productie: false };
  // private selectedJobRole: string;
  registrationCategory: string;
  approvers: IApprover[];
  weekNumber: string;
  week: string;
  year: string;
  monday: Date;
  tuesday: Date;
  wednesday: Date;
  thursday: Date;
  friday: Date;
  saturday: Date;
  sunday: Date;
  weeks: Array<number>;
  TimeRegistrationStatus = TimeRegistrationStatus;
  Jobrole = Jobrole;
  totalTimeRegistrationStatus: TimeRegistrationStatus;
  filterName: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private actionSheetCtrl: ActionSheetController,
    private formBuilder: FormBuilder,
    public employeeData: EmployeeData,
    private projectData: ProjectData,
    public timeRegistrationData: TimeRegistrationData,
    private translate: TranslateService,
    private platform: Platform,
    private selector: WheelSelector,
    public menuCtrl: MenuController
  ) {
    this.gender = Gender;
    this.editMode = EditMode;
    this.mode = navParams.get("editMode");
    if (!this.mode) {
      this.mode = this.editMode.browse;
    }
    this.isMobile = platform.is('cordova');
    this.isAndroid = platform.is('android');
    this.isTimeRegistration = navParams.get("isTimeRegistration");
    this.canLeave = (this.mode == EditMode.browse);
    menuCtrl.enable(true);

    this.employee = navParams.get("employee");
    if (!this.employee) {
      this.employee = new Employee();
    }
    this.approvers = [];
    this.initFormGroup();
    let monday = this.timeRegistrationData.mondayOfWeek(new Date());
    const week = navParams.get("week");
    const year = navParams.get("year");
    if (week && year) {
      monday = this.timeRegistrationData.getMondayOfWeekInYear(week, year);
    }
    this.initWeek(monday);
    this.initAll();
  }
  initAll() {
    this.employeeData.getApprovers().then((approvers: IApprover[]) => {
      this.approvers = approvers;
      this.employeeData.getEmployee(this.employeeData.loggedInEmployeeId).then((loggedInEmployee: IEmployee) => {
        this.loggedInEmployee = loggedInEmployee;
        if (this.mode === EditMode.new) {
          this.resetFormGroup();
        } else {
          if (this.isTimeRegistration) {
            this.employee = this.loggedInEmployee;
            this.employee.approver = null;
            this.resetFormGroup();
            this.setEmployeeTimeRegistrations();
            this.setEmployeeTimeRegistrationTypes();
          } else {
            this.employeeData.getEmployee(this.employee.employee_id).then((result: IEmployee) => {
              result.approver = !result.approver_id ? null : this.approvers.filter(approver => approver.approver_id === result.approver_id)[0];
              this.employee = result;
              this.resetFormGroup();
              this.setEmployeeTimeRegistrations();
              this.setEmployeeTimeRegistrationTypes();
            });
          }
        }
      });
    });
  }

  setEmployeeTimeRegistrationTypes() {
    this.employeeTimeRegistrationTypes = [];
    this.employee.jobroles.forEach((jobrole) => {
      this.jobRoles.find((foundJobrole) => {
        return foundJobrole.Jobrole == jobrole;
      }).timeRegistrationTypes.forEach((timeRegistrationType) => {
        if (this.employeeTimeRegistrationTypes.indexOf(timeRegistrationType) == -1) {
          this.employeeTimeRegistrationTypes.push(timeRegistrationType);
        }
      })
    });
    if (this.employee.jobroles.indexOf(Jobrole.productie) > -1) {
      this.registrationCategory = "Productie uren";
    } else if (this.employee.jobroles.indexOf(Jobrole.fiatteur) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.directie) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.management) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.administratie) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.loonadministratie) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.secretariaat) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.verkoop) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.werkvoorbereiding) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.productinnovatie) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.verhuur_projecten) > -1 ||
      this.employee.jobroles.indexOf(Jobrole.facilitair) > -1) {
      this.registrationCategory = "Kantoor uren";
    } else if ((this.employee.jobroles.indexOf(Jobrole.service_onderhoud) > -1 || this.employee.jobroles.indexOf(Jobrole.transport_plaatsen) > -1) && this.employee.jobroles.length <= 2) {
      this.registrationCategory = "Service/Transport uren";
    }
  }

  getHeaderStyle(project: IProject) {
    if (project) {
      return 'time-registrations-header-' + project.timeRegistrationsStatus;
    }
    return 'time-registrations-header-' + this.totalTimeRegistrationStatus;
  }

  getPlatformStyle() {
    if (this.platform.is('ios')) {
      if (this.registrationCategory == "Productie uren") {
        return 'platform-ios-hal';
      }
      return 'platform-ios';
    }
    if (this.registrationCategory == "Productie uren") {
      return 'platform-android-hal';
    }
    return 'platform-android';
  }

  ionViewCanLeave() {
    if (!this.canLeave && this.mode != this.editMode.browse) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('ARE_YOU SURE_LEAVE') + '?',
        subTitle: this.translate.instant('ALL_UNSAVED_LOST') + '!',
        buttons: [{
          text: this.translate.instant('NO')
        },
        {
          text: this.translate.instant('YES'),
          handler: data => {
            if (this.mode == this.editMode.edit) {
              this.cancel();
            } else {
              this.canLeave = true;
              this.navCtrl.pop();
            }
          }
        }]
      });
      alert.present();
      return false;
    }
  }

  initFormGroup() {
    let controlsConfig = {
      first_name: [null, Validators.required],
      middle_name: [null],
      last_name: [null, Validators.required],
      username: [null, Validators.required],
      approver: [null, Validators.required],
      password: [null],
      email: [null, Validators.email],
      gender: [null],
      phone: [null],
      street: [null],
      house_number: [null],
      city: [null],
      employee_number: [null, Validators.required],
      employee_number_verloning: [null, Validators.required],
      jobroles: [null, Validators.required],
      fte: [null, Validators.required],
      period_minimum: [null],
      scholing: [null],
      is_not_active: [null],
      king_id: [null, Validators.required]
    };
    this.formGroupEmployee = this.formBuilder.group(controlsConfig);
  }

  resetFormGroup() {
    this.formGroupEmployee.reset({
      first_name: this.employee.first_name,
      middle_name: this.employee.middle_name,
      last_name: this.employee.last_name,
      username: this.employee.username,
      approver: this.employee.approver,
      password: this.employee.password,
      email: this.employee.email,
      gender: this.employee.gender,
      phone: this.employee.phone,
      street: this.employee.address.street,
      house_number: this.employee.address.house_number,
      city: this.employee.address.city,
      employee_number: this.employee.employee_number,
      employee_number_verloning: this.employee.employee_number_verloning,
      jobroles: this.employee.jobroles,
      fte: this.employee.fte,
      period_minimum: this.employee.period_minimum,
      scholing: this.employee.scholing,
      is_not_active: this.employee.is_not_active,
      king_id: this.employee.king_id
    });
  }

  edit() {
    this.mode = this.editMode.edit;
    this.canLeave = false;
    this.content.resize();
  }

  save() {
    if (!this.isTimeRegistration) {
      if (this.formGroupEmployee.valid) {
        // update employee
        this.employee.first_name = this.formGroupEmployee.value.first_name;
        this.employee.middle_name = this.formGroupEmployee.value.middle_name;
        this.employee.last_name = this.formGroupEmployee.value.last_name;
        this.employee.username = this.formGroupEmployee.value.username;
        this.employee.password = this.formGroupEmployee.value.password;
        this.employee.email = this.formGroupEmployee.value.email;
        this.employee.gender = this.formGroupEmployee.value.gender;
        this.employee.phone = this.formGroupEmployee.value.phone;
        this.employee.address.street = this.formGroupEmployee.value.street;
        this.employee.address.house_number = this.formGroupEmployee.value.house_number;
        this.employee.address.city = this.formGroupEmployee.value.city;
        this.employee.employee_number = this.formGroupEmployee.value.employee_number;
        this.employee.employee_number_verloning = this.formGroupEmployee.value.employee_number_verloning;
        this.employee.fte = this.formGroupEmployee.value.fte;
        this.employee.period_minimum = this.formGroupEmployee.value.period_minimum;
        this.employee.scholing = this.formGroupEmployee.value.scholing;
        this.employee.is_not_active = this.formGroupEmployee.value.is_not_active;
        this.employee.approver_id = this.formGroupEmployee.value.approver.approver_id;
        this.employee.approver = this.formGroupEmployee.value.approver;
        this.employee.king_id = this.formGroupEmployee.value.king_id;

        this.employee.jobroles = this.formGroupEmployee.value.jobroles.map((jobrole) => {
          return parseInt(jobrole);
        });
        this.setEmployeeTimeRegistrationTypes();

        if (this.mode == this.editMode.new) {
          this.employeeData.createEmployee(this.employee).then((result) => {
            if (result == null) {
              // TODO show error toast
              throw new Error("Error save employee");
            } else {
              // TODO show success toast
            }
          });
        } else {
          this.employeeData.setEmployee(this.employee).then((result) => {
            if (result == null) {
              // TODO show error toast
              throw new Error("Error save employee");
            } else {
              // TODO show success toast
            }
          });
        }
        this.mode = this.editMode.browse;
        this.canLeave = true;
        this.content.resize();
      } else {
        for (const field in this.formGroupEmployee.value) {
          const control = this.formGroupEmployee.get(field);
          // for now only mark all elements as touched
          control.markAsTouched();
        }
      }
    } else {
      this.employeeData.setEmployee(this.employee).then((result) => {
        if (!result) {
          // TODO show error toast
          throw new Error("Error save employee");
        } else {
          // TODO show success toast
        }
      });
      this.mode = this.editMode.browse;
      this.canLeave = true;
      this.content.resize();
    }
  }

  cancel() {
    this.mode = this.editMode.browse;
    this.canLeave = true;
    if (!this.isTimeRegistration) {
      this.resetFormGroup();
    }
    this.content.resize();
  }

  initWeek(date: Date) {
    // console.log(date);
    this.month = this.months[date.getMonth()];
    this.monday = date;
    this.monday.setDate(this.monday.getDate() - this.monday.getDay() + 1);
    this.monday.setHours(0, 0, 0, 0);
    this.tuesday = new Date(this.monday);
    this.tuesday.setDate(this.monday.getDate() + 1);
    this.tuesday.setHours(0, 0, 0, 0);
    this.wednesday = new Date(this.monday);
    this.wednesday.setDate(this.monday.getDate() + 2);
    this.wednesday.setHours(0, 0, 0, 0);
    this.thursday = new Date(this.monday);
    this.thursday.setDate(this.monday.getDate() + 3);
    this.thursday.setHours(0, 0, 0, 0);
    this.friday = new Date(this.monday);
    this.friday.setDate(this.monday.getDate() + 4);
    this.friday.setHours(0, 0, 0, 0);
    this.saturday = new Date(this.monday);
    this.saturday.setDate(this.monday.getDate() + 5);
    this.saturday.setHours(0, 0, 0, 0);
    this.sunday = new Date(this.monday);
    this.sunday.setDate(this.monday.getDate() + 6);
    this.sunday.setHours(0, 0, 0, 0);

    let weekArrayObject = this.timeRegistrationData.getWeekNumber(this.monday);
    this.year = weekArrayObject[0].toString();
    this.week = weekArrayObject[1].toString();
    this.weekNumber = this.week.length == 1 ? this.year + "-01-01T00:0" + this.week : this.year + "-01-01T00:" + this.week;

    this.weeks = [];
    this.maxWeeks = this.timeRegistrationData.getWeeksInYear(this.monday.getFullYear());
    for (var index = 1; index <= this.maxWeeks; index++) {
      this.weeks.push(index);
    }
  }

  inputModal(project, timeRegistration) {
    if (this.isAndroid) {
      let titleText;
      switch (timeRegistration.type) {
        case TimeRegistrationType.DokterTandarts:
          titleText = "Reden dokter/tandartsbezoek";
          break;
        case TimeRegistrationType.VerlofADV:
        case TimeRegistrationType.VerlofSpeciaal:
        case TimeRegistrationType.VerlofVrijeDag:
          titleText = "Reden verlof";
          break;
        case TimeRegistrationType.Ziek:
          titleText = "Reden ziek";
          break;
        case TimeRegistrationType.OpbouwTijdVoorTijd:
          titleText = "Reden opbouw tijd voor tijd";
          break;
        default:
          //titleText = "Invoer tekst";
          break;
      }
      let inputModal = this.modalCtrl.create(EditTextModal, { editText: timeRegistration.description, title: titleText });
      inputModal.present();
      inputModal.onDidDismiss(newTextObject => {
        if (newTextObject) {
          timeRegistration.description = newTextObject.text;
          this.updateProjectTimeRegistrations(project);
        }
      });
    }
  }

  wheelSelectYear() {
    let data = {
      years: []
    }
    for (let index = 2018; index <= 2100; index++) {
      data.years.push({ description: index.toString() });
    }
    this.selector.show({
      title: "Selecteer jaar",
      items: [
        data.years
      ],
      theme: "dark",
      defaultItems: [{ index: 0, value: this.year }],
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        this.year = result[0].description;
        this.updateFromDateTime();
      },
      err => console.log(`wheelSelectYear Error: ${err}`)
    );
  }

  wheelSelectWeek() {
    let data = {
      weeks: []
    }
    for (let index = 1; index <= this.maxWeeks; index++) {
      data.weeks.push({ description: index.toString() });
    }
    this.selector.show({
      title: "Selecteer week",
      items: [
        data.weeks
      ],
      theme: "dark",
      defaultItems: [{ index: 0, value: this.week }],
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        this.week = result[0].description;
        this.weekNumber = this.week.length == 1 ? this.year + "-01-01T00:0" + this.week : this.year + "-01-01T00:" + this.week;
        this.updateFromDateTime();
      },
      err => console.log('wheelSelectWeek Error: ' + err)
    );
  }

  wheelSelectTimeRegistration(timeRegistration: ITimeRegistration, dayHHmm: string) {
    if (!this.checkEnableTimeregistrationInput(timeRegistration)) {
      return;
    }
    let data = {
      uren: [],
      minuten: [{ description: "00" }, { description: "30" }]
    }
    for (let index = 0; index < 24; index++) {
      let mm = index.toString();
      if (mm.length == 1) {
        mm = "0" + mm;
      }
      data.uren.push({ description: mm })
    }
    this.selector.show({
      title: "Uren en halve uren",
      items: [
        data.uren,
        data.minuten
      ],
      defaultItems: [{ index: 0, value: timeRegistration[dayHHmm].substr(0, 2) }, { index: 1, value: timeRegistration[dayHHmm].substr(3, 2) }],
      theme: "dark",
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        timeRegistration[dayHHmm] = result[0].description + ':' + result[1].description;
        this.updateTimeRegistration(timeRegistration, dayHHmm);
      },
      err => console.error(`wheelSelectTimeRegistration Error: ${err}`)
    );

  }

  nextWeek() {
    this.monday = new Date(this.monday.getTime() + this.weekInMilliseconds);
    this.initWeek(this.monday);
    this.setEmployeeTimeRegistrations();
  }

  previousWeek() {
    this.monday = new Date(this.monday.getTime() - this.weekInMilliseconds);
    this.initWeek(this.monday);
    this.setEmployeeTimeRegistrations();
  }

  updateFromDateTime() {
    this.monday = this.timeRegistrationData.getMondayOfWeekInYear(this.weekNumber.substr(14, 2), this.year);
    this.initWeek(this.monday);
    this.setEmployeeTimeRegistrations();
  }

  setEmployeeTimeRegistrations(noRecalculateTotal?: boolean) {
    this.employee.projectsFiltered = [];
    return new Promise<void>(resolve => {
      this.timeRegistrationData.getEmployeeTimeRegistrations(this.employee.employee_id, this.year, this.week).then((timeRegistrations) => {
        if (!timeRegistrations) {
          timeRegistrations = [];
        }

        if (noRecalculateTotal) {
          this.setTimeRegistrations(timeRegistrations);
          return;
        }
        this.projectData.getProjects().then(() => {
          this.employee.projects = this.projectData.projects.filter((project) => project.is_active);
          this.employee.projects.forEach((project) => {
            project.timeRegistrationsStatus = TimeRegistrationStatus.empty;
            project.timeRegistrations = [];
            project.timeRegistrationsFiltered = [];
          });
          // set project timeRegistrations
          this.employee.timeRegistrations = timeRegistrations.filter((timeRegistration) => (timeRegistration.type == 0 || timeRegistration.type > 4) && timeRegistration.project_id && timeRegistration.project_id.indexOf("\u0000") == -1);
          let extraProjectIds = [];
          let extraProjects = [];
          let extraTimeRegistrations = [];
          this.employee.timeRegistrations.forEach((timeRegistration) => {
            let isActiveProject = false;
            // add timeRegistrations to correct project
            for (let index = 0; index < this.employee.projects.length; index++) {
              let project = this.employee.projects[index];
              if (project.project_id == timeRegistration.project_id) {
                project.timeRegistrations.push(timeRegistration);
                project.timeRegistrationsFiltered.push(timeRegistration);
                isActiveProject = true;
                break;
              }
            }
            //if not active add project
            if (!isActiveProject) {
              if (extraProjectIds.indexOf(timeRegistration.project_id) == -1) {
                extraProjectIds.push(timeRegistration.project_id);
                extraProjects.push(this.projectData.getProject(timeRegistration.project_id));
              }
              extraTimeRegistrations.push(timeRegistration);
            }
          });

          if (extraProjects) {
            Promise.all(extraProjects).then(result => {
              if (result) {
                result.forEach((project) => {
                  project.timeRegistrations = [];
                  project.timeRegistrationsFiltered = [];
                  this.employee.projects.push(project);
                });
                extraTimeRegistrations.forEach((timeRegistration) => {
                  // add extra timeRegistrations to correct project
                  for (let index = 0; index < this.employee.projects.length; index++) {
                    let project = this.employee.projects[index];
                    if (project.project_id == timeRegistration.project_id) {
                      project.timeRegistrations.push(timeRegistration);
                      project.timeRegistrationsFiltered.push(timeRegistration);
                      break;
                    }
                  }
                });
                this.setTimeRegistrations(timeRegistrations).then(() => {
                  resolve();
                });
                resolve();
              }
            });
          } else {
            this.setTimeRegistrations(timeRegistrations).then(() => {
              resolve();
            });
          }
        });
      });
    });
  }

  setTimeRegistrations(timeRegistrations): Promise<void> {
    return new Promise(resolve => {
      // set leave timeRegistrations
      this.employee.leave = new Project(" Afwezigheid", "");
      this.employee.leave.is_active = true;
      this.employee.leave.timeRegistrationsFiltered = timeRegistrations.filter((timeRegistration) => timeRegistration.type != 0 && timeRegistration.type != 10 &&(timeRegistration.type <= 100 || timeRegistration.type >= 300) && timeRegistration.project_id.indexOf("\u0000") > -1);

      this.employee.tft = new Project(" Tijd voor tijd", "");
      this.employee.tft.is_active = true;
      this.employee.tft.timeRegistrationsFiltered = timeRegistrations.filter((timeRegistration) => (timeRegistration.type == 0 || timeRegistration.type == 10) && timeRegistration.project_id.indexOf("\u0000") > -1);

      // set office timeRegistrations
      this.employee.office = new Project(" Kantoor Algemeen", "");
      this.employee.office.is_active = true;
      this.employee.office.timeRegistrationsFiltered = timeRegistrations.filter((timeRegistration) => timeRegistration.type > 100 && timeRegistration.type <= 200 && timeRegistration.project_id.indexOf("\u0000") > -1);

      // set service timeRegistrations
      this.employee.service_transport = new Project(" Service/Transport Algemeen", "");
      this.employee.service_transport.is_active = true;
      this.employee.service_transport.timeRegistrationsFiltered = timeRegistrations.filter((timeRegistration) => (timeRegistration.type > 200 && timeRegistration.type < 300) && timeRegistration.project_id.indexOf("\u0000") > -1);

      this.filterAndCalculateTimeRegistrations();
      resolve();
    });
  }

  filterTimeRegistrations() {
    if (this.employee.projects) {
      this.employee.projectsFiltered = this.employee.projects.filter(project => project.name.toLowerCase().indexOf(this.filterName.toLowerCase()) > -1);
    }
  }
  filterAndCalculateTimeRegistrations() {
    this.filterProjectsByRegistrationCategory().then(() => {
      this.employee.totalHours = 0;
      this.employee.totalMonday = 0;
      this.employee.totalTuesday = 0;
      this.employee.totalWednesday = 0;
      this.employee.totalThursday = 0;
      this.employee.totalFriday = 0;
      this.employee.totalSaturday = 0;
      this.totalTimeRegistrationStatus = TimeRegistrationStatus.empty;

      this.calculateProjectTimeRegistrations(this.employee.leave);
      this.calculateProjectTimeRegistrations(this.employee.tft);
      this.calculateProjectTimeRegistrations(this.employee.service_transport);
      this.calculateProjectTimeRegistrations(this.employee.office);
      this.employee.projects.forEach((project) => {
        this.calculateProjectTimeRegistrations(project);
      });
      if (this.registrationCategory == 'Productie uren' && this.filterName) {
        this.filterTimeRegistrations();
      }
    });
  }

  filterProjectsByRegistrationCategory() {
    return new Promise<void>(resolve => {
      switch (this.registrationCategory) {
        case "Productie uren":
          this.employee.projects.sort(function (a, b) {
            if (a.hall < b.hall) return -1;
            if (a.hall > b.hall) return 1;
            return 0;
          });
          this.employee.projectsFiltered = this.employee.projects;
          break;
        case "Kantoor uren":
          this.employee.projects.sort(function (a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
          this.employee.projectsFiltered = [this.employee.office].concat(this.employee.projects.filter((project) => project.timeRegistrations.length > 0));
          break;
        case "Service/Transport uren":
          this.employee.projects.sort(function (a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
          this.employee.projectsFiltered = [this.employee.service_transport].concat(this.employee.projects.filter((project) => project.timeRegistrations.length > 0));
          break;
        case "Afwezigheid uren":
          this.employee.projectsFiltered = [this.employee.leave, this.employee.tft];
          break;
      }
      resolve();
    });
  }

  calculateProjectTimeRegistrations(project: IProject): IProject {
    project.timeRegistrationsStatus = TimeRegistrationStatus.empty;
    project.totalHours = 0;
    project.totalMonday = 0;
    project.totalTuesday = 0;
    project.totalWednesday = 0;
    project.totalThursday = 0;
    project.totalFriday = 0;
    project.totalSaturday = 0;

    if (project.timeRegistrationsFiltered && project.timeRegistrationsFiltered.length > 0) {
      project.timeRegistrationsStatus = project.timeRegistrationsFiltered[0].status;

      project.totalMonday = this.timeRegistrationData.getHoursForProjectDay(project, 'mondayHHmm');
      project.totalTuesday = this.timeRegistrationData.getHoursForProjectDay(project, 'tuesdayHHmm');
      project.totalWednesday = this.timeRegistrationData.getHoursForProjectDay(project, 'wednesdayHHmm');
      project.totalThursday = this.timeRegistrationData.getHoursForProjectDay(project, 'thursdayHHmm');
      project.totalFriday = this.timeRegistrationData.getHoursForProjectDay(project, 'fridayHHmm');
      project.totalSaturday = this.timeRegistrationData.getHoursForProjectDay(project, 'saturdayHHmm');

      this.employee.totalHours += project.totalHours = this.timeRegistrationData.getHoursForProject(project);
      this.employee.totalMonday += project.totalMonday;
      this.employee.totalTuesday += project.totalTuesday;
      this.employee.totalWednesday += project.totalWednesday;
      this.employee.totalThursday += project.totalThursday;
      this.employee.totalFriday += project.totalFriday;
      this.employee.totalSaturday += project.totalSaturday;

      let newTimeRegistrationStatus = this.checkProjectStatus(project, this.totalTimeRegistrationStatus);
      if (newTimeRegistrationStatus) {
        this.totalTimeRegistrationStatus = newTimeRegistrationStatus;
      }
    }
    return project;
  }

  addProject() {
    let projectModal = this.modalCtrl.create(SelectProjectModal);
    projectModal.present();
    projectModal.onDidDismiss(project => {
      if (project) {
        project.timeRegistrationsFiltered = [];
        this.employee.projectsFiltered.push(project);
        this.employee.projectsFiltered.sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        setTimeout(() => {
          this.scrollTo(project.project_id);
        });
      }
    });
  }

  trackByFn(index, approver: IApprover) {
    return approver.approver_id;
  }

  scrollTo(elementId: string) {
    this.content.scrollTo(0, 0, 0).then(() => {
      let el = document.getElementById(elementId);
      let yOffset = el.offsetTop;
      this.content.scrollTo(0, yOffset - 50);
    });
  }

  processNewTimeRegistration(project: IProject, timeRegistration: ITimeRegistration) {
    project.timeRegistrations.push(timeRegistration);
    this.setEmployeeTimeRegistrations().then(() => {
      setTimeout(() => {
        this.scrollTo(project.project_id);
      });
    });
  }

  newTimeRegistration(project: IProject) {
    let timeRegistrationTypeIds = [];
    project.timeRegistrationsFiltered.forEach(timeRegistration => {
      timeRegistrationTypeIds.push(timeRegistration.type)
    });
    let buttonArray = [];
    switch (this.registrationCategory) {
      case "Productie uren":
        if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Projecten) == -1) {
          buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Projecten));
        }
        if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Werkbespreking) == -1) {
          buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Werkbespreking));
        }
        break;
      case "Kantoor uren":
        const timeRegistrationTypePipe = new TimeRegistrationTypePipe();
        this.employeeTimeRegistrationTypes.forEach((timeRegistrationType) => {
          if (timeRegistrationTypeIds.indexOf(timeRegistrationType) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, timeRegistrationType));
          }
        });
        break;
      case "Service/Transport uren":
        if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Reisuren) == -1) {
          buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Reisuren));
        }
        if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Schoonmaak) == -1) {
          buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Schoonmaak));
        }
        if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Service) == -1) {
          buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Service));
        }
        if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Transport) == -1) {
          buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Transport));
        }
        break;
      case "Afwezigheid uren":
        if (project.name === " Tijd voor tijd") {
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.OpbouwTijdVoorTijd) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.OpbouwTijdVoorTijd));
          }
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.OpnameTijdVoorTijd) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.OpnameTijdVoorTijd));
          }
        } else {
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.DokterTandarts) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.DokterTandarts));
          }
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.VerlofADV) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.VerlofADV));
          }
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.VerlofSpeciaal) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.VerlofSpeciaal));
          }
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.VerlofVrijeDag) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.VerlofVrijeDag));
          }

          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.FeestDag) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.FeestDag));
          }
          if (timeRegistrationTypeIds.indexOf(TimeRegistrationType.Ziek) == -1) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Ziek));
          }
          if (this.employee.scholing) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.Scholing));
          }
          if (this.employee.fte === 0) {
            buttonArray.push(this.getActionSheetTimeRegistrationTypeButtonObject(project, TimeRegistrationType.NietGewerkt));
          }
        }
        break;
    }
    buttonArray.sort(function (a, b) {
      if (a.text < b.text) return -1;
      if (a.text > b.text) return 1;
      return 0;
    });
    buttonArray.push({
      text: "Annuleren",
      role: "cancel",
      handler: () => {
        return true;
      }
    });
    this.actionSheet = this.actionSheetCtrl.create({
      buttons: buttonArray
    });
    if (buttonArray.length > 1) {
      this.actionSheet.present();
    }
  }

  getActionSheetTimeRegistrationTypeButtonObject(project: IProject, timeRegistrationType: TimeRegistrationType) {
    return {
      text: new TimeRegistrationTypePipe().transform(timeRegistrationType),
      handler: () => {
        this.actionSheet.dismiss().then(value => {
          this.timeRegistrationData.createTimeRegistration(new TimeRegistration(this.employee.employee_id, project.project_id, parseInt(this.year), parseInt(this.week), timeRegistrationType)).then((timeRegistration) => {
            this.processNewTimeRegistration(project, timeRegistration);
          }, error => {
            console.log(error)
            const alert = this.alertCtrl.create({
              message: JSON.stringify(error.error[1].king_result),
              buttons: ['Ok']
            });
            alert.present();
          })
        });
        return false;
      }
    };
  }

  deleteTimeRegistration(project: IProject, timeRegistration: ITimeRegistration) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('DELETE') + '?',
      subTitle: this.translate.instant('ARE_YOU SURE_DELETE', { value: 'deze urenregistratie "' + new TimeRegistrationTypePipe().transform(timeRegistration.type) + '"' }) + '?',
      cssClass: 'tv-delete-alert',
      buttons: [{
        text: this.translate.instant('NO')
      },
      {
        text: this.translate.instant('YES'),
        handler: () => {
          this.timeRegistrationData.deleteTimeRegistration(timeRegistration).then(() => {
            let foundIndex = -1;
            for (let index = 0; index < project.timeRegistrations.length; index++) {
              if (project.timeRegistrations[index].time_registration_id == timeRegistration.time_registration_id) {
                foundIndex = index;
              }
            }
            if (foundIndex > -1) {
              project.timeRegistrations.splice(foundIndex, 1);
            }
            if (timeRegistration.type > 4 && project.timeRegistrations.length == 0) {
              let foundIndex = this.employee.projects.indexOf(project);
              if (foundIndex > -1) {
                this.employee.projects.splice(foundIndex, 1);
              }
            }
            this.setEmployeeTimeRegistrations();
          });
        }
      }]
    });
    alert.present();
  }

  showRemark(timeRegistration: ITimeRegistration) {
    let alert = this.alertCtrl.create({
      title: 'Opmerking(en)',
      subTitle: timeRegistration.remarks,
      buttons: ['Ok']
    });
    alert.present();
  }

  setStatusOk() {
    for (let index = 0; index < this.employee.projects.length; index++) {
      if (!this.checkProjectForEmptyTimeRegistrations(this.employee.projects[index])) {
        return;
      }
    }
    if (!this.checkProjectForEmptyTimeRegistrations(this.employee.office)) {
      return;
    }
    if (!this.checkProjectForEmptyTimeRegistrations(this.employee.service_transport)) {
      return;
    }
    if (!this.checkProjectForEmptyTimeRegistrations(this.employee.leave)) {
      return;
    }
    if (!this.checkProjectForEmptyTimeRegistrations(this.employee.tft)) {
      return;
    }

    this.totalTimeRegistrationStatus = TimeRegistrationStatus.submitted;
    this.updateProjects();
  }

  checkProjectForEmptyTimeRegistrations(project: IProject) {
    for (let index = 0; index < project.timeRegistrationsFiltered.length; index++) {
      const timeRegistration = project.timeRegistrationsFiltered[index];
      if (
        timeRegistration.mondayHHmm === '00:00' &&
        timeRegistration.tuesdayHHmm === '00:00' &&
        timeRegistration.wednesdayHHmm === '00:00' &&
        timeRegistration.thursdayHHmm === '00:00' &&
        timeRegistration.fridayHHmm === '00:00' &&
        timeRegistration.saturdayHHmm === '00:00' &&
        timeRegistration.type !== TimeRegistrationType.NietGewerkt
      ) {
        let alert = this.alertCtrl.create({
          title: 'Lege uren!',
          subTitle: 'Kan de uren niet indienen. Er zijn nog lege uren  op ' + project.name,
          buttons: ['Ok']
        });
        alert.present();
        return false;
      }
      if (timeRegistration.type < 100 && !timeRegistration.description) {
        const title = timeRegistration.type == 0 ? 'Reden bij tijd voor tijd leeg!' : 'Reden bij afwezigheid leeg!';
        let alert = this.alertCtrl.create({
          title: title,
          subTitle: 'De reden bij afwezigheid mag niet leeg zijn',
          buttons: ['Ok']
        });
        alert.present();
        return false;
      }
    }
    return true;
  }

  checkEnableTimeregistrationInput(timeRegistration) {
    return this.employeeData.jobRoles.indexOf(Jobrole.loonadministratie) > -1 ? true : (this.isTimeRegistration && (timeRegistration.status === TimeRegistrationStatus.open || timeRegistration.status === TimeRegistrationStatus.rejected));
  }

  setStatusNotOk() {
    this.totalTimeRegistrationStatus = TimeRegistrationStatus.open;
    this.updateProjects();
  }

  updateProjects() {
    let projectsArray = [];
    this.employee.projects.forEach((project) => {
      projectsArray.push(this.updateProjectTimeRegistrations(project));
    });
    projectsArray.push(this.updateProjectTimeRegistrations(this.employee.leave));
    projectsArray.push(this.updateProjectTimeRegistrations(this.employee.tft));
    projectsArray.push(this.updateProjectTimeRegistrations(this.employee.service_transport));
    projectsArray.push(this.updateProjectTimeRegistrations(this.employee.office));
    Promise.all(projectsArray).then(() => {
      this.setEmployeeTimeRegistrations();
    });
  }

  updateTimeRegistration(timeRegistration: ITimeRegistration, dayHHmm: string) {
    this.timeRegistrationData.setTimeRegistration(timeRegistration, dayHHmm).then(() => {

    }, error => {
      const alert = this.alertCtrl.create({
        message: JSON.stringify(error.error.king_result),
        buttons: ['Ok']
      });
      alert.onDidDismiss(()=> {
        this.initAll();
      });
      alert.present();
    });
    this.filterAndCalculateTimeRegistrations();
  }

  updateProjectTimeRegistrations(project: IProject) {
    let timeRegistrationsArray = [];
    project.timeRegistrationsFiltered.forEach((timeRegistration) => {
      if (timeRegistration.status == TimeRegistrationStatus.open || timeRegistration.status == TimeRegistrationStatus.rejected || timeRegistration.status == TimeRegistrationStatus.submitted) {
        timeRegistration.status = this.totalTimeRegistrationStatus;
        timeRegistrationsArray.push(this.timeRegistrationData.setTimeRegistrationStatus(timeRegistration));
      }
    });
    return new Promise<void>(resolve => {
      Promise.all(timeRegistrationsArray).then(() => {
        resolve();
      }, error => {
        const alert = this.alertCtrl.create({
          message: JSON.stringify(error.error.king_result),
          buttons: ['Ok']
        });
        alert.onDidDismiss(()=> {
          this.initAll();
        });
        alert.present();
      });
    });
  }

  checkProjectStatus(project: IProject, timeRegistrationsStatus): TimeRegistrationStatus {
    switch (project.timeRegistrationsStatus) {
      case TimeRegistrationStatus.open:
        return TimeRegistrationStatus.open;
      case TimeRegistrationStatus.rejected:
        return TimeRegistrationStatus.open;
      case TimeRegistrationStatus.submitted:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open) {
          return TimeRegistrationStatus.submitted;
        }
        break;
      case TimeRegistrationStatus.checked:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open && timeRegistrationsStatus != TimeRegistrationStatus.submitted) {
          return TimeRegistrationStatus.checked;
        }
        break;
      case TimeRegistrationStatus.approved:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open && timeRegistrationsStatus != TimeRegistrationStatus.checked) {
          return TimeRegistrationStatus.approved;
        }
        break;
      case TimeRegistrationStatus.done:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open && timeRegistrationsStatus != TimeRegistrationStatus.submitted) {
          return TimeRegistrationStatus.done;
        }
        break;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/employees/employee-details/employee-details.ts